import SyncableModel from './SyncableModel';
import Cycle from './Cycle';
import File from './File';

export default class CycleDisease extends SyncableModel {
    static name = 'CycleDisease'

    _fillable = [
      'id', 'cycle_id', 'disease_id',
      'laboratory_id',
      'other_disease',
      'logged_at',
      'image', // Not Used
      'remark',
      'positive',
      'indicated_at', // Not Used
      'created_at', 'updated_at',
      'deleted_at', 'synced_at'
    ]

    static endpoint = '/cycle_diseases'

    _casts = {
      positive: 'boolean'
    }

    static _childs = ['files'];

    static _parents = ['cycle'];

    static _boot() {
      super._boot();

      this.updating((cycleDisease: CycleDisease) => {
        if (cycleDisease.isDirty(cycleDisease.getKeyName())) {
          cycleDisease.relationFiles()
            .update({
              fileable_id: cycleDisease.getKey()
            });
        }
      });
    }

    relationCycle() {
      return Cycle.query().withoutGlobalScope('soft_delete').whereKey(this.getOriginal('cycle_id') || this.cycle_id);
    }

    relationFiles() {
      return File.query()
        .where(new File().qualifyColumn('fileable_id'), this.getOriginal(this.getKeyName()) || this.getKey())
        .where(new File().qualifyColumn('fileable_type'), 'App\\CycleDisease');
    }
}
